// @flow
import React from 'react';

import { checkEmployeeStatuses } from 'app/common/api/requests/food/check_employee_exists';


type Props = {
  id?: number,
  status: $Values<typeof checkEmployeeStatuses>,
}


const SnilsExist = ({ status }: Props) => {
  if (status) {
    return (
      <span>
        {'Этот номер СНИЛС уже используется другим пользователем'}
      </span>
    );
  }
  return null;
};

export default SnilsExist;
